'use client';

import { BlockComponentModel } from '@/components/cms/types/blok-component';

import ImageStrapi, {
  ImageStrapiProps,
} from '@/decodo/components/atoms/Image/ImageStrapi';
import {
  BlockHeader,
  BlockHeaderContent,
} from '@/features/utils/BlockHeaderContentDC';
import { BlockWrapper } from '@/features/utils/BlockWrapperDC';

import { SECTION_NAMES } from '@/components/integrations/trackingScripts/constants';
import { ImageBlock, ImageBlockProps } from '.';

interface ImageBlockStrapiProps {
  header: BlockHeader;
  image: ImageStrapiProps;
  isExpandable: ImageBlockProps['isExpandable'];
}

export const ImageBlockStrapi = ({
  block,
  ...rest
}: BlockComponentModel<ImageBlockStrapiProps>) => {
  const { header, image, isExpandable } = block;

  return (
    <BlockWrapper
      data-tracker-section={SECTION_NAMES.IMAGE_BLOCK}
      data-tracker-component={SECTION_NAMES.IMAGE_BLOCK}
      {...rest}
    >
      <BlockHeaderContent {...header}>
        <ImageBlock
          renderImage={(props) => (
            <ImageStrapi
              block={image}
              inner={{
                ...props,
                classNames: {
                  image: 'w-full rounded',
                },
              }}
            />
          )}
          isExpandable={isExpandable}
        />
      </BlockHeaderContent>
    </BlockWrapper>
  );
};
